import T from '../../services/language';
import styled from "styled-components";
import {useRef, useState} from "react";
import {Modal} from "antd";
import {ButtonCancel, ButtonGroup, ButtonSubmit} from "../../components/Button";
import {clone} from "lodash";

export const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #101820;
  margin-bottom: 16px;
`;
export const ImageView = styled.div`
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;

  & img {
    width: 100%;
    height: auto;
  }
`;
export const Desc = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #22313F;

  p, h1, h2, h3, h4, h5, ul {
    margin-bottom: 3px;
    margin-block: 0;
  }
`;

export const Quantity = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;
export const QuantityTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #22313F;
`;
export const QuantityActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
export const QuantityAction = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #BEBEBE;
  border-radius: 10px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #494949;
`;
export const QuantityValue = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #22313F;
  margin: 0 12px;
  min-width: 24px;
  text-align: center;
`;

export const FooterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;


const AddOnControlContainer = styled.div`
  margin-bottom: 16px;
`;
const AddOnControlLabel = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #5D5D5D;
  margin-bottom: 4px;
`;
const AddOnControlSelect = styled.div`
  border-radius: 10px;
  border: 1px solid #BEBEBE;
  background: #FFF;
  height: 50px;
  padding: 13px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AddOnControlSelectText = styled.div`
  color: #494949;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;

  & > .hidden {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  span {
    color: var(--primary-600, #1D896D);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }
`;
const AddOnControlSelectIcon = styled((props) => (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M17.9197 8.17969H11.6897H6.07975C5.11975 8.17969 4.63975 9.33969 5.31975 10.0197L10.4997 15.1997C11.3297 16.0297 12.6797 16.0297 13.5097 15.1997L15.4797 13.2297L18.6897 10.0197C19.3597 9.33969 18.8797 8.17969 17.9197 8.17969Z"
            fill="#626262"/>
    </svg>
))``;

const AddOnControlModal = styled.div`
  height: 500px;
  border-radius: 20px;
  background: #FFF;
  box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.28);
  z-index: 1001;
  position: relative;
  padding: 24px;
  display: flex;
  flex-direction: column;
`;
const AddOnControlModalHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  flex: none;
  overflow: hidden;
`;
const AddOnControlModalHeadTitle = styled.div`
  color: var(--ink-ink-600, #101820);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 150% */
`;
const AddOnControlModalHeadClose = styled.div`
  width: 24px;
  height: 24px;
  overflow: hidden;
`;
const AddOnControlModalBody = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: scroll;
  margin-top: 0px;
  margin-bottom: 12px;
`;
const AddOnControlModalBodyItems = styled.div`
`;
const AddOnControlModalFooter = styled.div`
  height: 48px;
  flex: none;
`;

const AddOnControlModalBodyItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  padding-bottom: 12px;
`;
const AddOnControlModalBodyItemCheck = styled.div`
  cursor: pointer;
  position: relative;
  z-index: 1;

  &.active {
    .uncheck {
      display: none;
    }
  }

  &.inactive {
    .checked {
      display: none;
    }
  }

  &.single {
    .box {
      display: none;
    }
  }

  &.multi {
    .choice {
      display: none;
    }
  }
`;
const AddOnControlModalBodyItemText = styled.div`
  color: var(--black-black-700, #494949);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const AddOnControl = (props) => {
    const mode: 'single' | 'multi' = props.mode || 'multi';
    const {value, onChange} = props;
    const preValueRef = useRef([]);
    const [modalVisible, setModalVisible] = useState(false);
    const options = props.options;
    const containerTextRef = useRef<any>();

    const onSelect = (item, index) => {
        if (mode === "single") {
            onChange(clone(value).includes(item) ? [] : [item]);
        }
        if (mode === "multi") {
            if (value.includes(item)) {
                onChange(clone(value).filter(x => x !== item));
            } else {
                const nextValue = clone(value);
                nextValue.push(item);
                onChange(nextValue);
            }
        }
    }

    const onSubmit = () => {
        setModalVisible(false);
    }

    const onOpen = () => {
        preValueRef.current = value;
        setModalVisible(true);
    }

    const onClose = () => {
        // reset value
        onChange(preValueRef.current);
        // close
        setModalVisible(false);
    }

    const getText = () => {
        const text: string = value.length ? value.join('| ') : "Default, no add-on";
        const width = (!!containerTextRef?.current ? (containerTextRef?.current?.clientWidth) : (window.innerWidth - 95));
        const maxTextCount = (width || 0) / 9;
        const subText = text.substring(0, maxTextCount);
        const nextText = text.substring(maxTextCount, text.length);

        return {
            text: text,
            content: subText.split('|').join(','),
            hidden: nextText.split('|').join(','),
            count: (value.length && !!nextText && (nextText.split('|').length) > 0) ? (nextText.split('|').length) : 0
        }
    }

    return (
        <>
            <AddOnControlContainer onClick={onOpen}>
                <AddOnControlLabel>{T('Add-on')}</AddOnControlLabel>
                <AddOnControlSelect>
                    <AddOnControlSelectText ref={containerTextRef}>
                        {getText().content + (!!getText().hidden ? "..." : "")}
                        {!!getText().count ? (<span>(+{getText().count})</span>) : null}
                        {/*<div className={'hidden'}>{getText().text}</div>*/}
                    </AddOnControlSelectText>
                    <AddOnControlSelectIcon/>
                </AddOnControlSelect>
            </AddOnControlContainer>
            <Modal centered open={modalVisible} modalRender={() => (
                <AddOnControlModal>
                    <AddOnControlModalHead>
                        <AddOnControlModalHeadTitle>{T('Add-on')}</AddOnControlModalHeadTitle>
                        <AddOnControlModalHeadClose>
                            <svg onClick={onClose} width="24" height="24" viewBox="0 0 24 24"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3165 18.7071 18.7071C18.3165 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                                      fill="#14181F"/>
                                <path fillRule="evenodd" clipRule="evenodd"
                                      d="M18.7071 5.29289C19.0977 5.68342 19.0977 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0977 5.68342 19.0977 5.29289 18.7071C4.90237 18.3166 4.90237 17.6835 5.29289 17.2929L17.2929 5.29289C17.6835 4.90237 18.3166 4.90237 18.7071 5.29289Z"
                                      fill="#22313F"/>
                            </svg>
                        </AddOnControlModalHeadClose>
                    </AddOnControlModalHead>
                    <AddOnControlModalBody className={'no-scrollbar'}>
                        <AddOnControlModalBodyItems>
                            {
                                options.map((item, index) => {
                                    const active = value.includes(item);
                                    return (
                                        <AddOnControlModalBodyItem onClick={() => onSelect(item, index)}
                                                                   key={index.toString()}>
                                            <AddOnControlModalBodyItemText>{item}</AddOnControlModalBodyItemText>
                                            <AddOnControlModalBodyItemCheck
                                                className={`${mode} ${active ? "active" : "inactive"}`}>
                                                <CheckBox className={'box uncheck'}/>
                                                <CheckedBox className={'box checked'}/>
                                                <CheckChoice className={'choice uncheck'}/>
                                                <CheckedChoice className={'choice checked'}/>
                                            </AddOnControlModalBodyItemCheck>
                                        </AddOnControlModalBodyItem>
                                    )
                                })
                            }
                        </AddOnControlModalBodyItems>
                    </AddOnControlModalBody>
                    <AddOnControlModalFooter>
                        <ButtonGroup>
                            <ButtonCancel onClick={onClose}>{T('Cancel')}</ButtonCancel>
                            <div style={{width: 8}}></div>
                            <ButtonSubmit onClick={onSubmit}>{T('Save')}</ButtonSubmit>
                        </ButtonGroup>
                    </AddOnControlModalFooter>
                </AddOnControlModal>
            )}/>
        </>

    )
}

const CheckBox = (props) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="18.5" height="18.5" rx="3.25" fill="white"/>
        <rect x="0.75" y="0.75" width="18.5" height="18.5" rx="3.25" stroke="#BEBEBE" strokeWidth="1.5"/>
    </svg>
)

const CheckedBox = (props) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" rx="4" fill="#40A68C"/>
        <path
            d="M15.9194 5.27492C16.0047 5.18788 16.1065 5.11873 16.2189 5.07152C16.3312 5.02431 16.4519 5 16.5737 5C16.6956 5 16.8163 5.02431 16.9286 5.07152C17.041 5.11873 17.1428 5.18788 17.2281 5.27492C17.5856 5.63617 17.5906 6.21992 17.2406 6.58742L9.84936 15.3249C9.76545 15.4171 9.66361 15.4911 9.55009 15.5426C9.43656 15.594 9.31374 15.6218 9.18912 15.6241C9.06451 15.6264 8.94073 15.6033 8.82535 15.5562C8.70998 15.509 8.60543 15.4389 8.51812 15.3499L4.02061 10.7924C3.84716 10.6155 3.75 10.3777 3.75 10.1299C3.75 9.88217 3.84716 9.64431 4.02061 9.46742C4.10592 9.38037 4.20774 9.31123 4.3201 9.26402C4.43246 9.21681 4.55311 9.1925 4.67499 9.1925C4.79687 9.1925 4.91752 9.21681 5.02988 9.26402C5.14224 9.31123 5.24406 9.38037 5.32936 9.46742L9.14436 13.3337L15.8944 5.30242C15.9021 5.29276 15.9105 5.28357 15.9194 5.27492Z"
            fill="white"/>
    </svg>

)

const CheckChoice = (props) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9.25" fill="white" stroke="#BEBEBE" strokeWidth="1.5"/>
    </svg>

)

const CheckedChoice = (props) => (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill="#40A68C"/>
        <circle cx="10" cy="10" r="3.75" fill="white"/>
    </svg>
)
